import { render, staticRenderFns } from "./select_product_transfer.vue?vue&type=template&id=7072ea04&scoped=true&"
import script from "./select_product_transfer.vue?vue&type=script&lang=js&"
export * from "./select_product_transfer.vue?vue&type=script&lang=js&"
import style0 from "./select_product_transfer.vue?vue&type=style&index=0&id=7072ea04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7072ea04",
  null
  
)

export default component.exports